import checkoutImage from 'assets/svg/checkout-icon.svg';
export const getIcon = () => checkoutImage;